module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [(_vm.selectedItem.length === 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "dropdowninput",
    staticClass: "dropdown-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholderValue,
      "autocomplete": "my-field-name"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : _c('input', {
    staticClass: "dropdown-selected",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.selectedItem
    },
    on: {
      "click": _vm.resetSelection
    }
  }), _vm._v(" "), (_vm.inputValue && !_vm.selectedItem) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "dropdown-list",
    style: ({
      'max-height': _vm.dropdownMaxHeight
    })
  }, _vm._l((_vm.itemList), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.itemVisible(item)),
        expression: "itemVisible(item)"
      }],
      key: item,
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          return _vm.selectItem(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-90f157dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90f157dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/formDropdownInput.vue
// module id = 1703
// module chunks = 2